import { AlertOctagon } from 'lucide-react';
import { TaskColumn } from './TaskColumn';
import { ISSUE_STATUSES, type TaskStatus, type TaskUI } from './types';

interface IssuesGroupProps {
  byStatus: Record<TaskStatus, TaskUI[]>;
  totals: Record<TaskStatus, number>;
  absoluteTotals: Record<TaskStatus, number>;
  onTaskClick?: (task: TaskUI) => void;
}

export function IssuesGroup({ byStatus, totals, absoluteTotals, onTaskClick }: IssuesGroupProps) {
  const totalIssues = ISSUE_STATUSES.reduce((acc, s) => acc + (totals[s] ?? 0), 0);

  return (
    <div className="relative flex-shrink-0">
      <div className="absolute -top-2.5 left-3 z-10 flex items-center gap-1.5 px-2 py-0.5 bg-raios-bg rounded text-[10px] uppercase tracking-wider font-semibold text-raios-danger-text">
        <AlertOctagon className="h-3 w-3" aria-hidden />
        <span>Issues</span>
        <span className="tabular-nums">{totalIssues}</span>
      </div>

      <div className="flex gap-3 p-3 pt-4 rounded-lg border border-dashed border-raios-danger/60 bg-raios-danger/5">
        {ISSUE_STATUSES.map((status) => (
          <TaskColumn
            key={status}
            status={status}
            tasks={byStatus[status]}
            total={totals[status] ?? 0}
            absoluteTotal={absoluteTotals[status] ?? 0}
            variant="issue"
            onTaskClick={onTaskClick}
          />
        ))}
      </div>
    </div>
  );
}
